module.exports = __webpack_public_path__ + "img/success.0e6c07a.png";